import { proxy } from 'valtio';

interface IsDeletingStore {
    isDeleting: boolean;
}

const store: IsDeletingStore = proxy({
    isDeleting: false,
});

const startDeleting = () => {
    store.isDeleting = true;
};

const finishDeleting = () => {
    store.isDeleting = false;
};

export const isTemplateDeleting = {
    store,
    startDeleting,
    finishDeleting,
};
